import {
  AXES,
  GET_AXES,
  GET_AXES_ERROR,
  GET_AXES_SUCCESS,
  INSERT_NEW_AXE,
  INSERT_NEW_AXE_ERROR,
  INSERT_NEW_AXE_SUCCESS,
  DELETE_AXE,
  DELETE_AXE_SUCCESS,
  DELETE_AXE_ERROR,
  EDIT_AXE,
  EDIT_AXE_SUCCESS,
  EDIT_AXE_ERROR,
  GENERATE_PLATES,
  GENERATE_PLATES_SUCCESS,
  GENERATE_PLATES_ERROR,
} from 'redux/actions';

export const getAxes = (page = 1) => ({
  type: GET_AXES,
  payload: { page },
});

export const getAxesSuccess = (message) => ({
  type: GET_AXES_SUCCESS,
  payload: { message },
});

export const getAxesError = (message) => ({
  type: GET_AXES_ERROR,
  payload: { message },
});

export const axes = ({ area_plate_axis: axes }) => ({
  type: AXES,
  payload: { axes },
});

export const insertNewAxe = (payload) => ({
  type: INSERT_NEW_AXE,
  payload,
});

export const insertNewAxeSuccess = (message) => ({
  type: INSERT_NEW_AXE_SUCCESS,
  payload: { message },
});

export const insertNewAxeError = (message) => ({
  type: INSERT_NEW_AXE_ERROR,
  payload: { message },
});

export const editAxe = (payload) => ({
  type: EDIT_AXE,
  payload,
});

export const editAxeSuccess = (message) => ({
  type: EDIT_AXE_SUCCESS,
  payload: { message },
});

export const editAxeError = (message) => ({
  type: EDIT_AXE_ERROR,
  payload: { message },
});

export const deleteAxe = (payload) => ({
  type: DELETE_AXE,
  payload,
});

export const deleteAxeSuccess = (message) => ({
  type: DELETE_AXE_SUCCESS,
  payload: { message },
});

export const deleteAxeError = (message) => ({
  type: DELETE_AXE_ERROR,
  payload: { message },
});

export const generatePlates = () => ({
  type: GENERATE_PLATES,
});

export const generatePlatesSuccess = (message) => ({
  type: GENERATE_PLATES_SUCCESS,
  payload: { message },
});

export const generatePlatesError = (message) => ({
  type: GENERATE_PLATES_ERROR,
  payload: { message },
});
